export const API_ENDPOINT = (process.env
  .REACT_APP_API_URL as unknown) as string;
export const USE_SCANNER_EMULATOR = process.env.REACT_APP_USE_SCANNER_EMULATION;
export const AI_CHAT_API_URL = process.env.REACT_APP_AI_CHAT_API_URL;
export const APP_MODULE_DEBUG = Boolean(process.env.REACT_APP_APPMODUDLE_DEBUG);
